import { render, staticRenderFns } from "./ApprovedBackOrder.vue?vue&type=template&id=5a959e17&scoped=true"
import script from "./ApprovedBackOrder.vue?vue&type=script&lang=js"
export * from "./ApprovedBackOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a959e17",
  null
  
)

export default component.exports